import { types } from './types';
import Navigate from "./Navigate/Navigate"
import EndProcess from "./EndProcess/EndProcess";

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */



function Actions(action, showAlert, variables, setOpenVariable, findElementName, getAutomNamesIDs, allFlow) {
    switch (action.actionName) {
        case types.NAVIGATE: return <Navigate action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} findElementName={findElementName} getAutomNamesIDs={getAutomNamesIDs} allFlow={allFlow}/>;
        case types.ENDPROCESS: return <EndProcess action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} findElementName={findElementName} getAutomNamesIDs={getAutomNamesIDs}/>;
        default: break;
    }
}

export default Actions;